module.exports = __webpack_public_path__ + "img/resched-rej.0888bac8.svg";